import store from '@/store'

const dashboardsRoutes: any = {
    path: 'd',
    name: 'project-dashboard',
    meta: { title: 'project_menu.dashboard' },
    component: () => import('@/views/Project/Dashboard/views/Index.vue'),
    beforeEnter: (to, from, next) => {
        if (store.getters.authenticated) {
            next()
        } else {
            next({ name: 'SignIn', query: { url: to.fullPath } })
        }
    },
    children: [
        {
            path: '/',
            name: 'create-dashboard',
            meta: { title: 'project_menu.dashboard' },
            components: {
                default: () => import('@/views/Project/Dashboard/views/CreateDashboard.vue'),
            },
        },
        {
            path: ':dashboardId/w',
            name: 'add-widget',
            meta: { title: 'project_menu.dashboard' },
            components: {
                default: () => import('@/views/Project/Dashboard/views/Dashboard.vue'),
                dialog: () => import('@/views/Project/Dashboard/views/AddWidget.vue'),
            },
        },
        {
            path: ':dashboardId(\\d+)',
            name: 'dashboardId',
            meta: { title: 'project_menu.dashboard' },
            components: {
                default: () => import('@/views/Project/Dashboard/views/Dashboard.vue'),
            },
        },
    ],
}

export default dashboardsRoutes
